import { BsFacebook, BsTwitterX } from 'react-icons/bs';
//import { FaFacebookF, FaYoutube, FaTwitter, FaLinkedin } from 'react-icons/fa';
//import{BsYoutube, BsLinkedin} from 'react-icons/bs';
//import { FaApple, FaAndroid } from "react-icons/fa";
import { BsInstagram, BsTiktok } from 'react-icons/bs';
//import { FaCcVisa, FaCcMastercard, FaCcAmex} from "react-icons/fa";
//import Interac from '../../../assets/icon/interac.webp';
//import { RiSecurePaymentLine } from "react-icons/ri";
import { FaCcStripe } from 'react-icons/fa';
import gigImage from '../../../assets/logo/hplogo.jpg';
import { useTranslation } from 'react-i18next';
import VersionBadge from './VersionBadge';
import { openPrivacyChoices } from '../../../components/privacyChoices';
import { all_routes } from '../../../core/data/routes/all_routes';

const Footer = () => {
  const { t } = useTranslation();
  const routes = all_routes;

  return (
    <div className="w-full bg-gradient-to-tr from-[#2D617A] via-neutral-9000 to-gray-950 text-white flex-col items-center p-5 mt-10">
      {/* Footer Links */}
      <div className="w-full sm:flex justify-around mt-10">
        {/* Logo and Tagline */}
        <div className="text-center flex flex-col items-center">
          <img
            src={gigImage}
            alt="HirePanther"
            loading="lazy"
            className="w-69 h-32 rounded-lg"
          />

          <p className="text-[15px] font-primary mb-1">
            {t('footer.description')} <br />
          </p>

          {/* Social Media Icons */}
          <div className="flex justify-center space-x-4 mt-5">
            <a
              href="https://www.facebook.com/share/1JaKcoYiuR/.com"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-gray-600 rounded-full hover:bg-gray-500"
            >
              <BsFacebook className="w-5 h-5 text-white" />
            </a>

            {/* YouTube
            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-gray-600 rounded-full hover:bg-gray-500"
            >
              <BsYoutube className="w-5 h-5 text-white" />
            </a>
            */}

            <a
              href="https://x.com/hirepanther"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-gray-600 rounded-full hover:bg-gray-500"
            >
              <BsTwitterX className="w-5 h-5 text-white" />
            </a>

            {/* LinkedIn
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-gray-600 rounded-full hover:bg-gray-500"
            >
              <BsLinkedin className="w-5 h-5 text-white" />
            </a>
            */}

            <a
              href="https://www.instagram.com/hirepanther"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-gray-600 rounded-full hover:bg-gray-500"
            >
              <BsInstagram className="w-5 h-5 text-white" />
            </a>

            <a
              href="https://www.tiktok.com/@hirepanther"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-gray-600 rounded-full hover:bg-gray-500"
            >
              <BsTiktok className="w-5 h-5 text-white" />
            </a>
          </div>

          {/* Payments / Trust */}
          <div className="flex items-center space-x-2 text-sm text-gray-300 mt-5">
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-300 mb-1 ml-6">
                {t('footer.paymentsTrust')}
              </span>

              <FaCcStripe
                className="w-8 h-8 text-white hover:text-gray-300 transition"
                title="Stripe"
              />

              {/* Other payment icons
              <FaCcVisa
                className="w-8 h-8 text-white hover:text-gray-300 transition"
                title="Visa"
              />
              <FaCcMastercard
                className="w-8 h-8 text-white hover:text-gray-300 transition"
                title="Master Card"
              />
              <FaCcAmex
                className="w-8 h-8 text-white hover:text-gray-300 transition"
                title="Amex"
              />
              <RiSecurePaymentLine
                className="w-8 h-8 text-white hover:text-gray-300 transition"
                title="PCI Secure"
              />
              <img
                src={Interac}
                alt="Interac"
                className="w-8 h-6 hover:text-gray-300 transition"
                title="Interac"
              />
              */}
            </div>
          </div>

          {/* Download App Section */}
          {/*
          <div className="mt-6">
            <h4 className="text-[16px] font-semibold mb-2">
              Download App
            </h4>

            <div className="flex space-x-4">
              <a
                href="https://apps.apple.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-3 py-2 bg-gray-700 rounded-lg hover:bg-gray-600"
              >
                <FaApple className="w-8 h-8 mr-2 text-white" />
                <span className="text-sm text-white">iOS</span>
              </a>

              <a
                href="https://play.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-3 py-2 bg-gray-700 rounded-lg hover:bg-gray-600"
              >
                <FaAndroid className="w-8 h-8 mr-2 text-[#3DDC84]" />
                <span className="text-sm text-white">Android</span>
              </a>
            </div>
          </div>
          */}
        </div>

        {/* First section - currently disabled */}
        {/*
        <div>
          <h3 className="text-[18px] font-semibold">
            {t('footer.sections.0.title')}
          </h3>

          <ul className="text-[15px] font-primary space-y-1 mt-2">
            <li>
              <a href="/categories" className="hover:underline">
                {t('footer.sections.0.items.item1')}
              </a>
            </li>

            <li>
              <a href="/popular-services" className="hover:underline">
                {t('footer.sections.0.items.item2')}
              </a>
            </li>

            <li>
              <a href="/browse-provider" className="hover:underline">
                {t('footer.sections.0.items.item3')}
              </a>
            </li>

            <li>
              <a href="/deals-offers" className="hover:underline">
                {t('footer.sections.0.items.item4')}
              </a>
            </li>

            <li>
              <a href="/new-trending" className="hover:underline">
                {t('footer.sections.0.items.item5')}
              </a>
            </li>

            <li>
              <a href="/locations" className="hover:underline">
                {t('footer.sections.0.items.item6')}
              </a>
            </li>
          </ul>
        </div>
        */}

        {/* Right side menus container */}
        <div className="flex flex-wrap gap-8 laptop:gap-16 justify-start">
          {/* For Customers + Company */}
          <div className="flex flex-col laptop:flex-row gap-6 laptop:gap-16">
            {/* Customers */}
            <div>
              <h3 className="text-[18px] font-semibold whitespace-nowrap">
                {t('footer.sections.1.title')}
              </h3>

              <ul className="text-[15px] font-primary space-y-1 mt-2">
                {/* How It Works
                <li>
                  <a href="/how-it-works" className="hover:underline">
                    {t('footer.sections.1.items.item1')}
                  </a>
                </li>
                */}

                {/* Bookings Help
                <li>
                  <a href="/bookings-help" className="hover:underline">
                    {t('footer.sections.1.items.item2')}
                  </a>
                </li>
                */}

                {/* Redeem Voucher
                <li>
                  <a href="/redeem-voucher" className="hover:underline">
                    {t('footer.sections.1.items.item3')}
                  </a>
                </li>
                */}

                {/* Referrals
                <li>
                  <a href="/referrals" className="hover:underline">
                    {t('footer.sections.1.items.item4')}
                  </a>
                </li>
                */}

                <li>
                  <a href="/safety-insurance" className="hover:underline">
                    {t('footer.sections.1.items.item5')}
                  </a>
                </li>

                {/* Affiliate
                <li>
                  <a href="/affiliate" className="hover:underline">
                    {t('footer.sections.1.items.item6')}
                  </a>
                </li>
                */}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h3 className="text-[18px] font-semibold whitespace-nowrap">
                {t('footer.sections.2.title')}
              </h3>

              <ul className="text-[15px] font-primary space-y-1 mt-2">
                <li>
                  <a href="/about-hirepanther" className="hover:underline">
                    {t('footer.sections.2.items.item1')}
                  </a>
                </li>

                {/* Careers
                <li>
                  <a href="/careers" className="hover:underline">
                    {t('footer.sections.2.items.item2')}
                  </a>
                </li>
                */}

                {/* Press
                <li>
                  <a href="/press" className="hover:underline">
                    {t('footer.sections.2.items.item3')}
                  </a>
                </li>
                */}

                <li>
                  <a
                    href="https://www.blog.hirepanther.ca/"
                    className="hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('footer.sections.2.items.item4')}
                  </a>
                </li>

                <li>
                  <a href="/contact" className="hover:underline">
                    {t('footer.sections.2.items.item5')}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Support & Legal */}
          <div className="flex flex-col laptop:flex-row gap-6 laptop:gap-16">
            {/* Support */}
            <div>
              <h3 className="text-[18px] font-semibold whitespace-nowrap">
                {t('footer.sections.3.title')}
              </h3>

              <ul className="text-[15px] font-primary space-y-1 mt-2">
                <li>
                  <a
                    href="https://www.help.hirepanther.ca/"
                    className="hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('footer.sections.3.items.item1')}
                  </a>
                </li>

                {/* Report Issue
                <li>
                  <a href="/report-issue" className="hover:underline">
                    {t('footer.sections.3.items.item2')}
                  </a>
                </li>
                */}

                <li>
                  <a href="/accessibility" className="hover:underline">
                    {t('footer.sections.3.items.item3')}
                  </a>
                </li>

                <li>
                  <a href={routes.supportTicket} className="hover:underline">
                    {t('footer.sections.3.items.item4')}
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h3 className="text-[18px] font-semibold whitespace-nowrap">
                {t('footer.sections.4.title')}
              </h3>

              <ul className="text-[15px] font-primary space-y-1 mt-2">
                <li>
                  <a href="/terms-services" className="hover:underline">
                    {t('footer.sections.4.items.item1')}
                  </a>
                </li>

                <li>
                  <a href="/privacy-policy" className="hover:underline">
                    {t('footer.sections.4.items.item2')}
                  </a>
                </li>

                <li>
                  <a href="/cookie-policy" className="hover:underline">
                    {t('footer.sections.4.items.item3')}
                  </a>
                </li>

                <li>
                  <a href="/advertising-policy" className="hover:underline">
                    {t('footer.sections.4.items.item4')}
                  </a>
                </li>

                <li>
                  <a href="/tax-policy" className="hover:underline">
                    {t('footer.sections.4.items.item5')}
                  </a>
                </li>

                <li>
                  <a href="/dmca" className="hover:underline">
                    {t('footer.sections.4.items.item6')}
                  </a>
                </li>

                <li>
                  <a href="/sitemap" className="hover:underline">
                    {t('footer.sections.4.items.item7')}
                  </a>
                </li>

                <li>
                  <button
                    type="button"
                    onClick={openPrivacyChoices}
                    className="hover:underline"
                  >
                    Privacy choices
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Version Info */}
      <div className="w-full flex justify-end mt-5">
        <VersionBadge />
      </div>

      {/* Copyright */}
      <div className="flex items-center justify-center w-full mt-0">
        <div className="block text-center space-y-1">
          <p className="text-[12px] font-medium leading-relaxed flex items-baseline gap-1">
            <span className="inline-flex">
              <svg
                width="10"
                height="10"
                viewBox="0 0 30 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M30 0H0V20H30V0Z" fill="#F0F0F0" />
                <path d="M10 0H0V20H10V0Z" fill="#D80027" />
                <path d="M30 0H20V20H30V0Z" fill="#D80027" />

                <path
                  d="M16.875 11.3889L18.75 10.4514L17.8125 9.98275V9.04526L15.9375 9.98275L16.875 8.10777H15.9375L15 6.70148L14.0625 8.10777H13.125L14.0625 9.98275L12.1875 9.04526V9.98275L11.25 10.4514L13.125 11.3889L12.6563 12.3264H14.5313V13.7327H15.4688V12.3264H17.3438L16.875 11.3889Z"
                  fill="#D80027"
                />
              </svg>
            </span>

            <span>{t('footer.tagline')}</span>
          </p>

          <p className="text-[12px]">{t('footer.copyright')}</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
